import { CheckboxGroup } from "../Form/CheckboxGroup";

export function FilterMenu({ field, options, control, isGrouped }) {
    return (
        <div className="absolute bg-white shadow-lg rounded-xl border-none mt-1 w-full z-10 p-4 max-h-60 overflow-y-auto">
            {isGrouped ? (
                options.map((group, index) => (
                    <div key={index} className="mb-4">
                        <h3 className="font-bold mb-2">{group.label}</h3>
                        <CheckboxGroup
                            options={group.options}
                            control={control}
                            name={field.name} // Use the same name for all groups
                        />
                    </div>
                ))
            ) : (
                <CheckboxGroup
                    options={options}
                    control={control}
                    name={field.name}
                />
            )}
        </div>
    );
}